module.exports = __webpack_public_path__ + "static/media/404_page.cfbeb140.svg";